import contentApi from './api';

export * from './api';
export default contentApi;
